module.exports = __webpack_public_path__ + "public/img/logo-horizontal.bbacbbe6.svg";